// eslint-disable-next-line import/no-extraneous-dependencies
import { OrderPageLimit } from 'pando-constants';

const mutation = {
  SET_ALL_ORDERS(state, orders) {
    const listLength = orders.length;
    if (listLength > 0) {
      if (listLength < OrderPageLimit) {
        state.isEmptyPaginate = true;
      } else {
        state.isEmptyPaginate = false;
      }
    } else {
      state.isEmptyPaginate = true;
    }
    state.all = orders;
  },

  REMOVE_FROM_ALL_ORDERS(state, orderNumber) {
    state.all = state.all.filter(order => order.order_number !== orderNumber);
  },

  SET_ORDER_PROCESSING(state, status) {
    state.isOrderProcessing = status;
  },

  SET_ALL_ORDERS_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_ORDER(state, order) {
    state.order = order;
  },

  UPDATE_ORDER(state, payload) {
    state.order = { ...state.order, ...payload };
  },

  SET_ORDER_LOADING(state, status) {
    state.isOrderLoading = status;
  },

  SET_FILTER(state, filter) {
    state.filter = filter;
  },

  SET_COUNT(state, count) {
    state.count = count;
  },

  SET_MATERIALS(state, materials) {
    state.materials = materials;
  },

  SET_MATERIAL_LOADING(state, status) {
    state.isMaterialLoading = status;
  },

  SET_LR(state, materials) {
    state.lr = materials;
  },

  SET_LR_LOADING(state, status) {
    state.isLrLoading = status;
  },

  SET_DEPOT(state, depotId) {
    state.currentDepot = depotId;
  },

  SET_DEPOT_CONFIGURATION(state, data) {
    state.currentDepotConfiguration = data;
  },

  SET_PAGINATED_DATA(state, data) {
    const allOrder = state.all;
    const listLength = data.length;
    if (listLength > 0) {
      if (listLength < OrderPageLimit) {
        state.isEmptyPaginate = true;
      } else {
        state.isEmptyPaginate = false;
      }
    } else {
      state.isEmptyPaginate = true;
    }
    const result = allOrder.concat(data);
    state.all = result;
  },

  SET_PAGINATION_STATUS(state, status) {
    state.isPaginating = status;
  },

  SET_HYPERTRACK(state, data) {
    state.hyperTrack = data;
  },

  SET_LATEST_ORDER(state, orderNo) {
    state.latestUpdated = orderNo;
  },

  SET_LOCATION_DATA(state, data) {
    state.locationData = data;
  },

  ORDER_BULK_PROCESSING(state, data) {
    state.isUploading = data;
  },

  SET_MATERIAL_HEADER(state, data) {
    state.materialHeaders = data;
  },

  SET_GRN(state, data) {
    state.grn = data;
  },

  SET_GRN_LOADING(state, data) {
    state.grnLoading = data;
  },

  SET_TRUCK_CHANGE_COMMENTS(state, data) {
    state.changeTruckComments = data;
  },
  SET_FILTER_TERM_TAG(state, data) {
    state.filter_term_tags = data;
  },
  SET_FILTER_SEARCH_TERM(state, data) {
    state.filter_search_term = data;
  },
  SLICE_FILTER_SEARCH_TERM(state, idx) {
    state.filter_search_term.splice(idx, 1);
  },
  ADD_FILTER_SEARCH_TERM(state, data) {
    state.filter_search_term.push(data);
  },
  SLICE_FILTER_TAG_TERM(state, idx) {
    state.filter_term_tags.splice(idx, 1);
  },
  ADD_FILTER_TAG_TERM(state, data) {
    state.filter_term_tags.push(data);
  },
  ADD_GRN_DETAIL(state, data) {
    state.grnDetails[data.id] = data;
    state.grnDetails = { ...state.grnDetails };
  },
  UPDATE_RETURN_MATERIALS(state, data) {
    state.returnMaterialDetails = data;
  },
  RETURN_MATERIALS_WARNED_ONCE(state, data) {
    state.returnMaterialWarnedOnce = data;
  },
  ADD_ALL_GRN_DETAIL(state, data) {
    state.grnDetails = { ...data };
  },
  UPDATE_MATERIAL_COMMENT(state, data) {
    const materialIndex = state.materials.materials.findIndex(material =>
      material.id === data.id);
    if (materialIndex !== -1) {
      state.materials.materials[materialIndex].epod.comment = data.comment;
      state.materials.materials[materialIndex].comment = data.comment;
      state.materials = { ...state.materials };
    }
  },
  CLEAR_GRN_DETAIL(state, data) {
    state.grnDetails = data;
  },
  SET_PAGE(state, data) {
    state.filter.page = data;
  },
  SET_INDENT_TRACKING(state, data) {
    state.trackingList = data;
  },
  SET_LOADER_FOR_APPROVAL_DATA(state, data) {
    state.isApprovalDataLoading = data;
  },
  SET_CONSIGNMENT_TRACKING(state, data) {
    state.consignmentTrackingList = data;
  },
  SET_CONSIGNMENT_TRACK_LOADING(state, data) {
    state.isConsignmentTrackLoading = data;
  },

  SET_RETURN_INDENTS(state, { data, masterOrderId }) {
    const allOrder = state.all;
    const masterIndex = state.all.findIndex(val => val.order_number === masterOrderId);
    if (masterIndex !== -1) {
      allOrder[masterIndex] = {
        ...allOrder[masterIndex],
        returnIndents: { ...data, ...{ parentIndentId: allOrder[masterIndex].id } },
      };
      // eslint-disable-next-line no-underscore-dangle
      if (data._id) {
        allOrder[masterIndex] = {
          ...allOrder[masterIndex],
          // eslint-disable-next-line no-underscore-dangle
          ...{ child_indent_ids: [data._id] },
        };
      }
      state.all = [...allOrder];
    }
  },

  INIT_SUB_DELIVERY_DETAILS(state) {
    state.subDeliveryDetails = [];
    state.hasEmptySubDeliveryList = false;
    state.subDeliveryPage = 1;
    state.isSubDeliveryLoading = false;
  },
  SET_PACKING_SUMMARY(state, data) {
    state.deliverySummary = data;
  },
  SET_SUB_DELIVERY_PAGE(state, data) {
    state.subDeliveryPage = data;
  },
  SET_SUB_DELIVERY_DETAILS_LOADING(state, data) {
    state.isSubDeliveryLoading = data;
  },
  SET_CARTON_FETCH(state, data) {
    state.isCartonFetchOpen = data;
  },
  SET_SUB_DELIVERY_DETAILS(state, data) {
    const result = (state.subDeliveryPage > 1) ? state.subDeliveryDetails.concat(data) : data;
    state.subDeliveryDetails = result;
    if (data.length) {
      state.subDeliveryPage += 1;
      state.hasEmptySubDeliveryList = false;
    } else {
      state.hasEmptySubDeliveryList = true;
    }
  },
  SET_SUB_DELIVERY_DETAIL(state, { data, index }) {
    state.subDeliveryDetails[index] = data;
    state.subDeliveryDetails = [...state.subDeliveryDetails];
  },
  SET_DELIVERY_NUMBER(state, data) {
    state.deliveryNumberDetails = data;
    state.deliveryNumberDetails = [...state.deliveryNumberDetails];
  },
  SET_CAN_SHOW_SAVE_GRN(state, data) {
    state.canShowSaveGRN = data;
  },
  SET_INVOICE_DETAILS(state, data) {
    state.invoiceDetails = data;
  },
  HAS_USER_EDITED(state, data) {
    state.userEdited = data;
  },
  HAS_WARNED_ONCE(state, data) {
    state.warnedOnce = data;
  },
  GLOBAL_SEARCH_FILTER(state, data) {
    state.isGlobalFilter = data;
  },
  GLOBAL_SEARCH_Q(state, data) {
    state.globalSearchQ = data;
  },
  SET_FCM_DATA(state, data) {
    state.newFCMNotification = data;
  },
  SET_INTEGRATION_TIMELINE(state, data) {
    state.integrationTimeLine = data;
  },
  SET_RECONCILIATION(state, reconciliation) {
    state.reconciliation = reconciliation;
  },
  SET_RECONCILIATION_LOADING(state, status) {
    state.isReconciliationLoading = status;
  },
  SET_PAY_ANOMALY(state, result) {
    state.payAnomalyData = result;
  },
  SET_PAY_ANOMALY_LOADING(state, status) {
    state.payAnomalyLoading = status;
  },
  SET_COURIER_TRANSPORTER(state, status) {
    state.courierTransporters = status;
  },
  SET_MULTI_LR_LOADING(state, status) {
    state.isMultiLrLoading = status;
  },
};

export default mutation;
